module.exports = __webpack_public_path__ + "static/media/join.be143bfb.png";